import Component from '../abstracts/Component';
import {IS_VERIFALIA_VALIDATION} from "../utils/Environment";
import {validateEmail, VERIFALIA_SELECTORS} from "../utils/VerifaliaUtil";

export default class FormValidationComponent extends Component {
  logger() {
    return this.log;
  }

  static FORM() {
    let _private = {
      _validator() {
        return $.fn.validate;
      },

      _customRules: {
        _core182: function(value) {
          return !value.match(/[*?§±+#^×]/g);
        },
        _password: function(value) {
          return (
            value.match(/^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)\S{8,255}$/g) ||
            false
          );
        },
        _phoneNumber : function(value) {
          return (value.match(/^\+?\d+$/g) || false);
        },
        _capCheck: function(value, elem) {
          return _public.capCheck(value, elem, 'all');
        },
        _capLength: function(value, elem) {
          return _public.capCheck(value, elem, 'length');
        },
        _capBlock: function(value, elem) {
          return _public.capCheck(value, elem, 'blocked');
        },
        _creditCard: function(value, elem) {
          return $.payment.validateCardNumber(value);
        },
        _verifaliaEmail : function(value, elem) {
          return _public.verifaliaEmail(value,elem,IS_VERIFALIA_VALIDATION);
        },
      },

      countryCheck: {
        at: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        be: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        bg: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        hr: {
          length: '^.{5}$',
          blocked: '(?!(.*))',
        },
        cy: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        cz: {
          length: '^.{1,6}$',
          blocked: '(?!(.*))',
        },
        dk: {
          length: '^.{4}$',
          blocked: '^([1-8][0-9]{2}|9([0-6][0-9]|70)|3[8-9][0-9]{2})$',
        },
        ee: {
          length: '^.{1,5}$',
          blocked: '(?!(.*))',
        },
        fi: {
          length: '^.{5}$',
          blocked: '(?!(.*))',
        },
        fr: {
          length: '^.{5}$',
          blocked: '^(97[1-6][0-9]{2}|98(0{3}|[6-8][0-9]{2}))$',
        },
        de: {
          length: '^.{5}$',
          blocked: '^(7826(3|6)|27498)$',
        },
        gb: {
          length: '^.{1,7}$',
          blocked: '^(gy[1-8]|je[1-9])$',
        },
        gr: {
          length: '^.{5}$',
          blocked: '^(63086)$',
        },
        hu: {
          length: '^.{1,5}$',
          blocked: '(?!(.*))',
        },
        ie: {
          length: '.*',
          blocked: '(?!(.*))',
        },
        it: {
          length: '.*',
          blocked: '^(120|47(031|89[0-9]))$',
        },
        lv: {
          length: '^.{1,7}$',
          blocked: '(?!(.*))',
        },
        lt: {
          length: '^.{1,8}$',
          blocked: '(?!(.*))',
        },
        lu: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        mt: {
          length: '^.{1,8}$',
          blocked: '(?!(.*))',
        },
        nl: {
          length: '^.{1,7}$',
          blocked: '(?!(.*))',
        },
        pl: {
          length: '^.{1,6}$',
          blocked: '(?!(.*))',
        },
        pt: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        ro: {
          length: '^.{1,6}$',
          blocked: '(?!(.*))',
        },
        sk: {
          length: '^.{1,6}$',
          blocked: '(?!(.*))',
        },
        si: {
          length: '^.{4}$',
          blocked: '(?!(.*))',
        },
        es: {
          length: '^.{5}$',
          blocked: '^(3(5|8)[0-9]{3}|5(100[0-9]|2[0-9]{3}))$',
        },
        se: {
          length: '^.{5}$',
          blocked: '(?!(.*))',
        },
      },
    };

    let _public = {
      initializeAll() {
        console.log('Inizialize validation!');
        $.each($('.js-validate-form'), function(index, value) {
          _public.initialize(value);
        });
      },

      initialize(form) {
        let $form = $(form);
        _public.defaultValidator.bindInputValidation($form);
        $form.validate(_public.defaultValidator.objects.validation);
        $form.removeAttr('novalidate');
      },

      defaultValidator: {
        exist() {
          return $.isFunction(_private._validator());
        },

        addCustomRule(name, fn, msg) {
          $.validator.addMethod(name, fn, msg);
        },

        objects: {
          none: {
            required: false,
          },
          standard: {
            required: true,
            minlength: 1,
            core182: true,
          },
          password: {
            required: true,
            minlength: 1,
            password: true,
          },
          email: {
            required: true,
            minlength: 1,
            email: true,
          },
          numeric: {
            required: true,
            minlength: 1,
            digits: true,
          },
          capCheck: {
            required: true,
            core182: true,
            //capCheck: true,
          },
          capLength: {
            required: true,
            core182: true,
            //capLength: true,
          },
          creditcard: {
            required: true,
            core182: true,
            creditcard: true,
            //digits: true,
          },
          capBlock: {
            required: true,
            core182: true,
            //capBlock: true
          },
          phoneNumber: {
            required: true,
            phoneNumber: true
          },
          verifaliaEmail:{
            verifaliaEmail: true
          },
          validation: {
            onfocusout(element) {
              $(element).valid();
            },
            onfocusin(element) {
              let formField = $(element).parents('.mc-input-group');
              $(element).removeClass('error');
            },
            onsubmit: false,
            onkeyup: function() {},
            errorPlacement: function(error, element) {},
            highlight: function(element) {
              if (
                !$(element).data('validation') ||
                $(element).data('validation') === 'none'
              ) {
                return false;
              }
              this.settings.customFunction._light(element, true);
            },
            unhighlight: function(element) {
              if (
                !$(element).data('validation') ||
                $(element).data('validation') === 'none'
              ) {
                return false;
              }
              this.settings.customFunction._light(element, false);
            },
            /**
             Specify the validation rules
             */
            rules: {},
            /** custom functions */
            customFunction: {
              _light: function(element, addError) {
                addError = addError ? addError : false;
                /* forced to false because otherwise the toggleClass don't considers the undefined input value like a false */
                let inputElement = $(element);
                let formField = $(element).parents(".form-group");
                let warning = $("[data-verifalia-warning='true']",formField).length === 1;
                let success = !addError && !warning;

                inputElement
                  .toggleClass('error', addError)
                  .attr('aria-hidden', !addError);

                inputElement
                  .toggleClass('success', success)
                  .attr('aria-hidden', success);

                if (inputElement.parent().find('span.error').length == 1) {
                  inputElement
                  .parent()
                  .find('span.error')
                  .toggleClass('d-none', !addError)
                  .attr('aria-hidden', !addError);

                  inputElement
                  .parent()
                  .find('span.warning')
                  .toggleClass('d-none', warning)
                  .attr('aria-hidden', warning);
                }
                if (inputElement.parent().find('span.warning').length == 1) {
                  inputElement
                  .parent()
                  .find('span.warning')
                  .toggleClass('d-none', !warning)
                  .attr('aria-hidden', !warning);

                  inputElement
                  .parent()
                  .find('span.error')
                  .toggleClass('d-none', !addError)
                  .attr('aria-hidden', !addError);
                }
              },
            },
          },
        },

        bindInputValidation($form) {
          $.each(
            $form
              .find('input')
              .not("[type='hidden']")
              .not("[type='radio']")
              .not("[type='checkbox']"),
            function() {
              let self = $(this),
                name = self.attr('name'),
                validation = self.data('validation');
              _public.defaultValidator.setValidation(name, validation);
              if (self.val()) {
                self.addClass('used');
              }
            }
          );
        },

        setValidation(name, validation) {
          if (_public.defaultValidator.exist && validation) {
            _public.defaultValidator.objects.validation.rules[
              name
            ] = _public.defaultValidator.getValidation(validation);
          }
        },

        getValidation(validation) {
          return (
            _public.defaultValidator.objects[validation] ||
            _public.defaultValidator.objects.none
          );
        },
      },

      scrollToError() {
        let errorSelector = '.js-validate-form .form-error';
        if ($(errorSelector).length) {
          $(errorSelector).removeClass('hidden');
          $('html, body').animate({
            scrollTop: $(errorSelector)
              .eq(0)
              .offset().top,
          });
        }
      },

      capCheck(value, elem, check) {
        let country = document.body.dataset.website;
        let countryBilling = $(
          '#billingAddress\\.country , #billingAddress\\.country\\.isocode , #address\\.country\\.isocode'
        );

        if (countryBilling.length > 0 && check === 'length')
          country = countryBilling.val()
            ? countryBilling.val().toLowerCase()
            : country;

        let lengthRegExp = _private.countryCheck[country]
          ? _private.countryCheck[country].length
          : '.*';
        let blockedRegExp = _private.countryCheck[country]
          ? _private.countryCheck[country].blocked
          : '(?!(.*))';

        if (check === 'length') {
          lengthRegExp = new RegExp(lengthRegExp);
          return lengthRegExp.test(value);
        } else if (check === 'blocked') {
          blockedRegExp = new RegExp(blockedRegExp);
          return !blockedRegExp.test(value);
        } else {
          lengthRegExp = new RegExp(lengthRegExp);
          blockedRegExp = new RegExp(blockedRegExp);
          return lengthRegExp.test(value) && !blockedRegExp.test(value);
        }
      },
      verifaliaEmail: function(value,elem,isVerifaliaEnabled) {
        if(isVerifaliaEnabled){
          let $elem = $(elem);
          let email = $elem.val();
          let res = validateEmail(email);
          if(!res) return false;
          let isValid = res.emailValid === true;
          let hasWarning = res.emailWarning === true;

          let $parentForm = $elem.closest('.form-group');
          let inputName = $elem.attr('name') || ""
          let $errorMsg = $("[id='"+inputName+".warning']", $parentForm);

          $errorMsg.attr('data-verifalia-warning',false);
          if (isValid && !hasWarning) {
            return true;
          } else {
            if (!isValid) {
              return false;
            }
            if (hasWarning) {
              $errorMsg.attr('data-verifalia-warning',true);
              return true;
            }
          }
        }
        return false;
      },
    };

    _public.defaultValidator.addCustomRule(
      'core182',
      _private._customRules._core182
    );
    _public.defaultValidator.addCustomRule(
      'capCheck',
      _private._customRules._capCheck
    );
    _public.defaultValidator.addCustomRule(
      'capLength',
      _private._customRules._capLength
    );
    _public.defaultValidator.addCustomRule(
      'capBlock',
      _private._customRules._capBlock
    );
    _public.defaultValidator.addCustomRule(
      'password',
      _private._customRules._password
    );
    _public.defaultValidator.addCustomRule(
      'creditcard',
      _private._customRules._creditCard
    );
     _public.defaultValidator.addCustomRule(
      'verifaliaEmail',
      _private._customRules._verifaliaEmail
     );
     _public.defaultValidator.addCustomRule(
      'phoneNumber',
      _private._customRules._phoneNumber
     );
    return _public;
  }

  fixRequired(forms) {
    let formValidation =
      typeof document.createElement('input').checkValidity === 'function';
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    let isExplorer =
      navigator.appName === 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      ) ||
      (typeof $.browser !== 'undefined' && $.browser.msie === 1);

    if (!formValidation && (isSafari || isExplorer)) {
      forms = forms || $('form');

      forms.off('submit.fv').on('submit.fv', function(event) {
        $(this)
          .find('[required]')
          .each(function(i, input) {
            let $i = $(input),
              val = !!$i.val() ? $.trim($i.val()) : '',
              ctrl = $i.closest('.mc-input-group');

            ctrl.removeClass('has-error');
            ctrl.find('.radio > label, .checkbox > label').removeClass('error');
            ctrl
              .find('.radio > span.error, .checkbox > span.error')
              .addClass('hide');

            if (
              ['radio', 'checkbox'].indexOf($i.attr('type')) > -1 &&
              ctrl.find('input[required]:checked').length === 0
            ) {
              ctrl.addClass('has-error');
              ctrl.find('.radio > label, .checkbox > label').addClass('error');
              ctrl
                .find('.radio > span.error, .checkbox > span.error')
                .removeClass('hide');
            } else if (!isExplorer && val.length === 0) {
              ctrl.addClass('has-error');
            }
          });

        let first = $(this)
          .find('.has-error [required]')
          .first();
        let pos = first.position();
        if (pos && pos.top) {
          FormValidationComponent.FORM().scrollToError();
          first.focus();
        }
      });
    }
  }

  bindEvents() {
    this.$on(
      this.$customEvents.VALIDATION.bindValidation,
      FormValidationComponent.FORM().initializeAll
    );

    // Input custom label validation fix
    $(document).on('blur', 'input', {}, function() {
      // check if the input has any value (if we've typed into it)
      if ($(this).val()) $(this).addClass('used');
      else $(this).removeClass('used');
    });
  }

  render() {
    super.render();
    this.log('Field validation on!');
    let _this = this;

    this.moduleLoader.loadJqueryValidationAndExecute(module => {
      FormValidationComponent.FORM().initializeAll();
      _this.fixRequired();
      _this.bindEvents();
    });
  }
}
